module.exports = __webpack_public_path__ + "media/images/home/resources_icon-bb0aaab223f0deb5402336627da3134d.svg";